
/**
 * @http http请求
 * @author lixiang<lixiang02@baijiahulian.com>
 */
import {message} from 'antd';

/**
  * 统一化处理http请求
  *
  * @param {function} func 发送请求的方法
  * @param {object} params 发送请求的参数
  * @param {function} callback 请求成功的回调
  * @param {string} errorMessage 请求失败的提示信息
  */
export const fetchFunc = (
    func,
    params,
    callback,
    error,
    finalBack
) => {
    const errorIsFunction = typeof error === 'function';

    return func(params)
        .then(callback)
        .catch(errorIsFunction
            ? error
            : msg => {
                message.error({
                    title: error,
                    maskClosable: true,
                    content: msg
                });
            })
        .finally(finalBack);
};


/**
 * 获取cookie设置
 *
 */
export const getNextHttpCookieConfig = req => {
    const ua = req && req.headers ? req.headers['user-agent'] : navigator.userAgent;
    const headers = {};
    if ((ua.match(/micromessenger/i)) && (ua.match(/wxwork/i))) {
        headers.m = 'qywx';
    }
    if (req && req.headers && req.headers.cookie) {
        headers.cookie = req.headers.cookie;
    }

    return {headers};
};


/**
     * 传入对象返回url参数
     * @param {Object} data {a:1}
     * @returns {string}
     */
export function getParam(data) {
    return Object.keys(data).reduce((url, current) =>
        `${url}&${current}=${data[current] ? encodeURIComponent(data[current]) : ''}`, '');
}

/**
     * 将url和参数拼接成完整地址
     * @param {string} url url地址
     * @param {Json} data json对象
     * @returns {string}
     */
export function getUrl(url, data) {
    // 看原始url地址中开头是否带?，然后拼接处理好的参数
    return `${url}?${getParam(data)}`;
}

export const pageDto = {pageNum: 1, pageSize: 10};

export const DEFAULT_PAGE_NUM = 1;

export const DEFAULT_PAGE_SIZE = 20;
